<template>
  <div>
    <!-- Logo above card (optional)
    <v-app-bar class="text-center" :elevation="1">
      <v-img
        :src="require('@/assets/suuq.logo.svg')"
        alt="SUUQ Logo"
        @click="logoRoute"
      />
    </v-app-bar> -->

   <div class="d-flex align-center justify-center" style="height: 90vh">
      <v-card elevation="0" width="400" class="mx-auto">
        <v-card-title class="text-center mb-5">
          <v-img
            :src="require('@/assets/suuq.logo.svg')"
            alt="SUUQ Logo"
            height="180"
            @click="logoRoute"
            class="mb-n10"
          />
          Login with your email
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" class="ma-3">
            <v-text-field
              v-model="user.email"
              :rules="[rules.required]"
              class="mb-2"
              clearable
              variant="outlined"
              label="Email"
            ></v-text-field>
            <v-text-field
              v-model="user.password"
              :appendInnerIcon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              label="Password"
              hint="At least 8 characters"
              counter
              variant="outlined"
              @click:append-inner="show1 = !show1"
            ></v-text-field>
            <v-btn
              :loading="loading"
              block
              color="#b8860b"
              size="large"
              elevation="0"
              class="mt-3"
              @click="handleLogin"
            >
              <span class="text-white"> Login</span>
            </v-btn>
            <div class="text-center">
              <v-btn
                @click="forgottenPassword"
                variant="text"
                class="ml-n2 mb-n5"
                size="x-small"
                color="#b8860b"
                >Forgot your password?</v-btn
              >

                <div class="register-cta text-center mt-4">
              <span class="text-grey text-caption">Don’t have an account? </span>
              <router-link class="register-cta-link text-caption" :to="{ path: '/register' }">
                Create one
              </router-link>
            </div>
              <div class="mt-3 text-caption">
                <span class="text-grey">
                  By signing up I agree to the
                  <v-btn
                    @click="terms"
                    variant="text"
                    class="text-none ml-n1"
                    size="x-small"
                    color="blue"
                    >Terms and Conditions</v-btn
                  >
                  <span class="ml-n1"> and </span>
                  <v-btn
                    @click="policies"
                    variant="text"
                    class="text-none ml-n2"
                    size="x-small"
                    color="blue"
                    >Privacy Policies</v-btn
                  >
                </span>
              </div>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import User from "@/models/user";
import axios from "axios";

export default {
  data() {
    return {
      acceptTerms: false,
      formValid: false,
      dialog: false,
      user: new User("", "", ""), // expects { email, password } inside your model
      loading: false,
      show1: false,
      rules: {
        required: (v) => !!v || v === 0 || "Required.",
        min: (v) => (v?.length ?? 0) >= 8 || "Min 8 characters",
        emailMatch: () => `The email and password you entered don't match`,
        acceptTerms: (v) => v === true || "Please accept the Terms to continue",
      },
    };
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    validation() {
      return this.$store.state.tender?.validationErrors;
    },
  },

  methods: {
    logoRoute() {
      this.$router.push(this.$route.query.redirect || "/");
    },
    terms() {
      this.$router.push(this.$route.query.redirect || "/terms");
    },
    policies() {
      this.$router.push(this.$route.query.redirect || "/policies");
    },
    forgottenPassword() {
      this.$router.push(this.$route.query.redirect || "/forgotten-password");
    },

    async handleLogin() {
      // Validate form fields
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;

      this.loading = true;
      try {
        // 1) Laravel auth
        const userData = await this.$store.dispatch("auth/login", this.user);

        // 2) Firebase auth
        await this.$store.dispatch(
          "auth/firebaseAuth",
          userData.firebase_token
        );

        // 3) Redirect
        const redirectPath =
          userData.role?.slug === "admin"
            ? this.$route.query.redirect || "/admin"
            : this.$route.query.redirect || "/";

        this.$router.push(redirectPath);
        this.$store.dispatch("alert/success", "Login successful");
      } catch (error) {
        console.error("Login error:", error);
        this.$store.dispatch(
          "alert/error",
          error?.response?.data?.message || error.message || "Login failed"
        );
        // Ensure clean state on partial auth
        await this.$store.dispatch("auth/logout");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-btn::before {
  background-color: transparent;
}

/* Create-account CTA */
.register-cta {
  font-family: proxima-nova, GE-SS, noto, "Helvetica Neue", Helvetica, Arial;
  font-size: 14px;
  font-weight: 600;
  line-height: 24.5px;
  color: #b8860b;
}
.register-cta-link {
  color: inherit;
  text-decoration: none;
}
.register-cta-link:hover {
  text-decoration: underline;
}

/* Terms row inline layout */
.terms-row {
  display: inline-flex;
  align-items: center; /* vertical align with text */
  justify-content: center;
  gap: 8px; /* tight spacing */
  flex-wrap: wrap; /* wrap gracefully on small widths */
  line-height: 1.2;
  margin-top: 8px;
}
.nowrap {
  white-space: nowrap;
} /* keep “and Privacy Policies” together */

/* shrink & align the checkbox nicely with the text */
.inline-checkbox {
  margin: 0 2px !important;
  padding: 0 !important;
  transform: translateY(-1px); /* tiny nudge for baseline alignment */
}
.inline-checkbox .v-input__control {
  min-height: 0 !important;
}
.inline-checkbox .v-selection-control {
  height: 18px !important;
}
.inline-checkbox .v-selection-control__wrapper {
  width: 16px;
  height: 16px;
}
.inline-checkbox .v-icon {
  font-size: 16px;
}
</style>
